import { Icon } from '@chakra-ui/react';

export const Level = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <g clipPath="url(#clip0_62_130)">
      <path
        d="M1 17.7619V23H23V1H17.2381V6.2381H12.5238V10.9524H9.38095V14.0952H5.71429V17.7619H1Z"
        stroke="currentColor"
        fill="transparent"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_62_130">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);
